import { render } from "./BuildingDetail.vue?vue&type=template&id=1a2b94ef&scoped=true"
import script from "./BuildingDetail.vue?vue&type=script&lang=js"
export * from "./BuildingDetail.vue?vue&type=script&lang=js"

import "./BuildingDetail.vue?vue&type=style&index=0&id=1a2b94ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2b94ef"]])

export default __exports__